<ng-container *ngIf="isGoogleIcon; else matIconTemplate">
    <span
      class="material-symbols-outlined d-flex mx-auto"
      [ngClass]="{'material-symbols-filled': isFilled}"
      [ngStyle]="customStyle"
      matTooltip="{{ name?.display_name }}"
      [attr.aria-label]="name?.display_name || icon"
    >
      {{ icon }}
    </span>
  </ng-container>
  
  <ng-template #matIconTemplate>
    <mat-icon
      class="d-flex mx-auto"
      matTooltip="{{ name?.display_name }}"
      [ngStyle]="customStyle"
      [attr.aria-label]="name?.display_name || icon"
    >
      {{ icon }}
    </mat-icon>
  </ng-template>
  